/* @flow */
import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';

export class Select extends React.Component {
  onInputChange = (value) => {
    this.props.field.input.onBlur(value);
  }

  renderEmptyOption = () => {
    if (this.props.noEmptyOption) {
      return null;
    }
    if (this.props.placeHolder) {
      return (
        <option value="" disabled>
          {this.props.placeHolder}
        </option>
      );
    }
    return <option value=""></option>;
  }

  renderSelect() {
    const { field, options, selectClass } = this.props;
    let onChangeFunction = field.input.onChange;
    if (this.props.onChange) {
      onChangeFunction = (event) => {
        field.input.onChange(event.target.value);
        this.props.onChange(event.target.value, event);
      };
    }

    return (
      <select
        className={selectClass || 'form-select'}
        id={field.input.name}
        value={field.input.value || ''}
        onChange={onChangeFunction}
        disabled={this.props.disabled}
        aria-labelledby={this.props.ariaLabelledBy}
        style={this.props.style}
      >
      {this.renderEmptyOption()}
      {options.map(opt =>
          (
            <option value={ opt.value } key={ opt.key } >
            { opt.displayValue }
            </option>
          )
      )}
      </select>
    );
  }

  render() {
    const { containerClass, field, children, inlineStyle } = this.props;

    const inputClasses = classNames(
      containerClass,
      { 'has-error': field.meta.error && field.meta.submitFailed }
    );

    if (inlineStyle) {
      return (<span className={inputClasses}>
        { this.renderSelect() }
      </span>)
    }
    return (
      <div className={inputClasses}>
        {
          this.renderSelect()
        }
        { children }
      </div>
    );
  }
}

Select.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.object,
  options: PropTypes.array,
  placeHolder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  containerClass: PropTypes.string,
  selectClass: PropTypes.string,
  onChange: PropTypes.func,
  noEmptyOption: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaLabelledBy: PropTypes.string,
  inlineStyle: PropTypes.bool,
  style: PropTypes.object,
};
